<!-- Header -->
@if (globalService.isMobileStyle) {
  <app-topnav [titleI18n]="'app.userSettings_accountSetting.profile.title'" [enableBack]="true" />
}

<!-- Body -->
@if (globalService.isMobileStyle) {
  <ion-content class="ion-padding">
    <div class="profile-info">
      <ng-container [ngTemplateOutlet]="profileForm"></ng-container>
    </div>
  </ion-content>
} @else {
  <br />
  <nz-card [nzBordered]="false">
    <nz-tabset nzSize="large" [nzSelectedIndex]="selectedTab">
      <nz-tab [nzTitle]="profileTabTemplate">
        <ng-template #profileTabTemplate>
          <nz-icon nzType="user" nzTheme="outline" />
          {{ 'app.userSettings_accountSetting.profile.tabProfile' | i18n }}
        </ng-template>
        <ng-container [ngTemplateOutlet]="profileForm"></ng-container>
      </nz-tab>
      <nz-tab [nzTitle]="securityTabTemplate">
        <ng-template #securityTabTemplate>
          <nz-icon nzType="lock" nzTheme="outline" />
          {{ 'app.userSettings_accountSetting.profile.tabSecurity' | i18n }}
        </ng-template>
        <app-change-password></app-change-password>
      </nz-tab>
    </nz-tabset>
  </nz-card>
}

<!-- Footer -->
@if (globalService.isMobileStyle) {
  <ion-footer>
    <ion-toolbar>
      <ng-container [ngTemplateOutlet]="submitButton"></ng-container>
    </ion-toolbar>
  </ion-footer>
}

<!-- Form Template -->
<ng-template #profileForm>
  <form nz-form [formGroup]="form" class="form-add-edit">
    <nz-form-item>
      <nz-form-label [nzSpan]="globalService.isMobileStyle ? 12 : 7" nzLabelAlign="left">
        {{ 'app.userSettings_accountSetting.profile.userName' | i18n }}
      </nz-form-label>
      <nz-form-control [nzSpan]="12">
        <app-dynamic-input [formControlName]="'userName'" [config]="{ maxLength: 20 }" />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzSpan]="globalService.isMobileStyle ? 12 : 7" nzLabelAlign="left">
        {{ 'app.userSettings_accountSetting.profile.dateJoined' | i18n }}
      </nz-form-label>
      <nz-form-control [nzSpan]="12">
        <app-dynamic-input [formControlName]="'createDate'" />
      </nz-form-control>
    </nz-form-item>
    <ng-container [ngTemplateOutlet]="submitButton" *ngIf="!globalService.isMobileStyle"></ng-container>
  </form>
</ng-template>

<!-- Submit button -->
<ng-template #submitButton>
  <nz-form-item>
    <nz-form-control [nzOffset]="globalService.isMobileStyle ? 0 : 7" [nzSpan]="globalService.isMobileStyle ? 24 : 12">
      <button
        nz-button
        nzType="primary"
        [nzBlock]="globalService.isMobileStyle"
        [disabled]="form.invalid || (this.loadingSvc.isLoading$ | async) || !form.dirty"
        (click)="onSubmit()"
      >
        {{ 'common.button.submit' | i18n }}
      </button>
    </nz-form-control>
  </nz-form-item>
</ng-template>
